import { JmApi } from "../jm-api/jm-api";
import { DataInstance } from "./data-instance";

export class PathsView extends DataInstance {
  public static readonly BASE_URL =
    import.meta.env.VITE_CLEVERREACH_API_BASE_URL + "/jmapi/v1/cr-import";

  private data: {
    path_id: number;
    project_id: number;
    company_id: number;
    origin_id: number;
    origin_street: string;
    origin_house_number: string;
    origin_postal_code: string;
    origin_district: string;
    origin_geo: {
      coordinates: [number, number];
      type: string;
    };
    destination_id: number;
    destination_street: string;
    destination_house_number: string;
    destination_postal_code: string;
    destination_district: string;
    destination_geo: {
      coordinates: [number, number];
      type: string;
    };
    arrival: string;
    departure: string;
  };

  constructor(
    path_id: number,
    project_id: number,
    company_id: number,
    origin_id: number,
    origin_street: string,
    origin_house_number: string,
    origin_postal_code: string,
    origin_district: string,
    origin_geo: { coordinates: [number, number]; type: string } = {
      coordinates: [1, 1],
      type: "Point",
    },
    destination_id: number,
    destination_street: string,
    destination_house_number: string,
    destination_postal_code: string,
    destination_district: string,
    destination_geo: { coordinates: [number, number]; type: string } = {
      coordinates: [1, 1],
      type: "Point",
    },
    arrival: string,
    departure: string,
  ) {
    super();
    this.data = {
      path_id: path_id,
      project_id: project_id,
      company_id: company_id,
      origin_id: origin_id,
      origin_street: origin_street,
      origin_house_number: origin_house_number,
      origin_postal_code: origin_postal_code,
      origin_district: origin_district,
      origin_geo: origin_geo,
      destination_id: destination_id,
      destination_street: destination_street,
      destination_house_number: destination_house_number,
      destination_postal_code: destination_postal_code,
      destination_district: destination_district,
      destination_geo: destination_geo,
      arrival: arrival,
      departure: departure,
    };
  }

  static postUrlBuilder() {
    return PathsView.BASE_URL;
  }

  static getUrlBuilder(projectId: number, companyId: number, officeId: number) {
    return `${PathsView.BASE_URL}?projId=${projectId}&compId=${companyId}&officeId=${officeId}`;
  }

  get currentData(): object {
    return this.data;
  }

  get currentId(): number | undefined {
    return this.id;
  }

  set currentId(id: number | undefined) {
    this.id = id;
  }

  async post(chain: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      JmApi.post(PathsView.postUrlBuilder(), this.data)
        .then((_response) => {
          if (chain) {
            resolve("Strecken erfolgreich hinzugefügt");
          }
        })
        .catch((_response) => {
          if (chain) {
            reject("post unsuccessful");
          }
        });
    });
  }

  static getFailedGeocodingPaths(
    projectId: number,
    companyId: number,
    officeId: number,
  ): Promise<string> {
    return new Promise((resolve) => {
      JmApi.get(
        `${PathsView.getUrlBuilder(
          projectId,
          companyId,
          officeId,
        )}&where={"origin_geo"="NULL"}`,
      ).then((response) => {
        resolve(response.data);
      });
    });
  }

  static fromObject(o: object): PathsView | null {
    if (o["street"] && o["house_number"] && o["postal_code"] && o["district"]) {
      return new Adress(
        o["street"],
        o["house_number"],
        o["postal_code"],
        o["district"],
      );
    } else {
      return null;
    }
  }
}
